import { TextField } from "@material-ui/core";
import { FormHelperText } from "@material-ui/core";
import React from "react";
type Props = {
	search: string;
	setSearch: Function;
};

export const SearchFilter = ({ search, setSearch }: Props) => {
	return (
		<>
			<TextField
				style={{
					minWidth: "100%",
					margin: "15px 0px",
					backgroundColor: "#f5f8fa",
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
					paddingBottom: 0,
				}}
				label="Search"
				variant="outlined"
				margin="dense"
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				autoComplete="off"
			/>
			<FormHelperText style={{ marginBottom: 10, marginTop: -15 }}>
				Search by Source, Message or User
			</FormHelperText>
		</>
	);
};
